



















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

/**
 * DEV-3842 — Excel'den toplu faiz oranı ekleme/güncelleme.
 *
 * İki aşamalı: "Önizle" hiçbir şey yazmaz; sunucu dosyayı çözüp ya yapılacaklar
 * listesini (eklenecek / güncellenecek) ya da satır bazlı hata listesini döner.
 * "Onayla ve Kaydet" AYNI dosyayı ve önizlemenin özetini (plan_ozeti) yeniden
 * yollar; sunucu her şeyi baştan doğrular ve yalnız kullanıcının gördüğü planla
 * aynıysa yazar. Arada kayıtlar değişmişse 409 ile güncel plan gelir.
 *
 * Excel sunucuda çözülür; panele Excel kütüphanesi eklenmedi.
 *
 * Sunucunun yanıtına şekline bakmadan güvenilmez: API bazı hataları (bakım
 * modu, aşırı büyük gövde) HTTP 200 + {"error": …} olarak döndürür. Beklenen
 * alanları taşımayan 2xx yanıt başarı sayılmaz.
 */

// Sunucudaki sınırla aynı (config/faiz-oran-toplu.php → azami_dosya_kb). Çok
// büyük dosyayı sunucunun önündeki vekil keser ve tarayıcı yalnız "ağ hatası"
// görür; sınır burada da denetlenir ki kullanıcı sebebi öğrensin.
const AZAMI_DOSYA_BAYT = 1024 * 1024;

@Component({})
export default class FaizOranTopluEkle extends Vue {
  @Prop({ default: false }) value!: boolean;

  asama: string = "sec";
  // Her açılışta artar: faiz türü listesi sunucudan tazelenir ve önceki
  // açılıştan kalan geç yanıt yok sayılır.
  acilisNo: number = 0;
  faizTurleri: any[] = [];
  turlerYukleniyor: boolean = false;
  faizTuruId: any = null;
  dosya: File | null = null;
  // "Önizle" anında belleğe alınan kopya; önizleme ve kayıt AYNI baytları yollar.
  gonderilecek: File | null = null;

  plan: any = null;
  planUyarisi: string = "";
  hata: string = "";
  hatalar: any[] = [];
  onbellekMesaji: string = "";
  // Tür listesi alınamadıysa: dosya/tür değişince silinen `hata`dan ayrı tutulur.
  turHatasi: string = "";
  // Dosya, okunamadığı için kod tarafından kaldırıldı: uyarısı silinmesin.
  dosyaUyarisiKalsin: boolean = false;
  // Önizleme tablolarında sayfa başına satır (-1 = hepsi).
  sayfaBoyu: any = { eklenecek: 10, guncellenecek: 10 };
  // Kayıt isteği yanıtsız kaldı ya da anlaşılmaz yanıt geldi: oranlar yazılmış
  // OLABİLİR. Yeniden göndermek (ve önbelleği düşürmek) yalnız bu pencereden
  // yapılabildiği için pencere dış tıkla kapanmaz.
  kayitBelirsiz: boolean = false;

  yukleniyor: boolean = false;
  kaydediliyor: boolean = false;
  ornekIndiriliyor: boolean = false;

  hataBasliklari = [
    { text: "Satır", value: "satir", width: 80 },
    { text: "Sütun", value: "sutun", width: 160 },
    { text: "Hata", value: "mesaj", sortable: false },
  ];
  eklenecekBasliklari = [
    { text: "Satır", value: "satir", width: 70 },
    { text: "Tarih", value: "tarih" },
    { text: "Oran Türü", value: "oran_aylik_mi" },
    { text: "Aylık Oran", value: "aylik_oran", align: "end" },
    { text: "Yıllık Oran", value: "yillik_oran", align: "end" },
    { text: "UYAP Tip Kod", value: "uyap_tip_kod" },
    { text: "UYAP Genel Kod", value: "uyap_genel_kod" },
  ];
  guncellenecekBasliklari = [
    { text: "Satır", value: "satir", width: 70 },
    { text: "Tarih", value: "tarih" },
    { text: "Aylık Oran (eski → yeni)", value: "aylik", sortable: false },
    { text: "Yıllık Oran (eski → yeni)", value: "yillik", sortable: false },
    { text: "UYAP Kodları", value: "kodlar", sortable: false },
    { text: "Not", value: "not", sortable: false },
  ];

  get mesgul(): boolean {
    return this.yukleniyor || this.kaydediliyor;
  }

  get kapanmasin(): boolean {
    return this.mesgul || this.asama === "onbellek" || this.kayitBelirsiz;
  }

  get yapilacakYok(): boolean {
    return !!this.plan && this.plan.ozet.eklenecek === 0 && this.plan.ozet.guncellenecek === 0;
  }

  get adresTabani(): string {
    return this.$store.state.icwApiUrl + 'admin/faiz-oranlari/toplu/';
  }

  @Watch("value")
  onAcilisDegisti(acik: boolean) {
    if (acik) {
      this.sifirla();
    }
  }

  // Başka bir dosya ya da tür seçildiğinde önceki seçimin uyarısı artık
  // geçerli değildir; ekranda kalırsa yeni dosyanın hatası sanılır.
  @Watch("dosya")
  onDosyaDegisti() {
    if (this.dosyaUyarisiKalsin) {
      this.dosyaUyarisiKalsin = false;
      return;
    }
    this.eskiUyariyiSil();
  }

  @Watch("faizTuruId")
  onTurDegisti() {
    this.eskiUyariyiSil();
  }

  eskiUyariyiSil() {
    if (this.asama === "sec") {
      this.hata = "";
    }
  }

  sifirla() {
    this.asama = "sec";
    this.acilisNo++;
    this.faizTurleri = [];
    this.faizTuruId = null;
    this.dosya = null;
    this.gonderilecek = null;
    this.plan = null;
    this.planUyarisi = "";
    this.hata = "";
    this.hatalar = [];
    this.onbellekMesaji = "";
    this.kayitBelirsiz = false;
    this.turHatasi = "";
    this.dosyaUyarisiKalsin = false;
    this.sayfaBoyu = { eklenecek: 10, guncellenecek: 10 };
    this.turleriYukle();
  }

  /**
   * Faiz türleri her açılışta sunucudan istenir. İstek başarısız olursa
   * pencere sebebini söyler; boş bir listeyle açıklamasız kalmaz.
   */
  async turleriYukle() {
    const acilis = this.acilisNo;
    this.turlerYukleniyor = true;

    try {
      const yanit = await this.$http.get(this.$store.state.icwApiUrl + 'admin/faiz-turleri');
      if (acilis !== this.acilisNo) return;
      if (!Array.isArray(yanit.data)) throw new Error("beklenmeyen yanıt");
      this.faizTurleri = yanit.data;
    } catch (e) {
      if (acilis !== this.acilisNo) return;
      this.faizTurleri = [];
      this.turHatasi = "Faiz türleri alınamadı. Pencereyi kapatıp yeniden açın ya da biraz sonra deneyin.";
    } finally {
      if (acilis === this.acilisNo) {
        this.turlerYukleniyor = false;
      }
    }
  }

  /**
   * Seçicide türün adı + kimliği: aynı adlı ya da pasif türler ayırt
   * edilemezse oranlar yanlış türe yazılır ve toplu yazmanın geri alması yok.
   * Panelden silinen tür gerçekten silinmez, "silinecek" diye işaretlenir
   * (islem_turu = 3) ve listede kalır; o da etiketlenir.
   */
  turMetni(tur: any): string {
    const pasif = tur.aktif_mi === false || tur.aktif_mi === 0 || tur.aktif_mi === "0";
    const silinecek = Number(tur.islem_turu) === 3;
    return tur.isim + " (#" + tur.id + (pasif ? ", pasif" : "") + (silinecek ? ", silinecek" : "") + ")";
  }

  kapat() {
    if (this.mesgul) return;
    // Belirsiz kayıtta ilk yenileme, sunucu yazmayı bitirmeden okumuş olabilir;
    // "zaten kayıtlı" sonucunda da arkadaki liste eski kalmış olabilir.
    if (this.kayitBelirsiz || this.yapilacakYok) {
      this.$emit("kaydedildi");
    }
    this.$emit("input", false);
  }

  kapatIstegi(acik: boolean) {
    if (!acik) {
      this.kapat();
    }
  }

  async onizle() {
    if (this.mesgul || !this.faizTuruId || !this.dosya) return;
    this.hata = "";
    this.planUyarisi = "";

    // Sunucu da aynı denetimi yapar; burada yapılınca dosya boşuna yüklenmez.
    if (!/\.xlsx$/i.test(this.dosya.name)) {
      this.hata = "Yalnız .xlsx dosyası yüklenebilir. Örnek Excel'i indirip onu doldurun.";
      return;
    }

    if (this.dosya.size > AZAMI_DOSYA_BAYT) {
      this.hata = "Dosya çok büyük (en çok 1 MB). Yalnız oran satırlarını içeren sade bir dosya yükleyin.";
      return;
    }

    this.yukleniyor = true;

    try {
      // Dosya bir kez belleğe alınır ve önizleme ile kayıt o kopyayı yollar:
      // kullanıcı önizlemeden sonra dosyayı diskte değiştirse de onayladığı
      // içerik gider. Seçildikten sonra diskte değişmiş dosyayı Chromium
      // okutmaz; o durumda yeniden seçtirilir.
      try {
        this.gonderilecek = await this.bellegeAl(this.dosya);
      } catch (e) {
        this.dosyaUyarisiKalsin = true;
        this.dosya = null;
        this.gonderilecek = null;
        this.hata = "Dosya okunamadı. Seçtikten sonra değiştirdiyseniz ya da taşıdıysanız dosyayı yeniden seçin.";
        return;
      }

      // Nesne gövdesi axios eklentisinde FormData'ya çevrilir; dosya öyle gider.
      const yanit = await this.$http.post(this.adresTabani + 'onizle', {
        faiz_turu_id: this.faizTuruId,
        dosya: this.gonderilecek,
      });

      if (!this.planMi(yanit.data)) {
        this.hata = "Sunucudan beklenmeyen bir yanıt geldi; önizleme yapılamadı. Biraz sonra yeniden deneyin.";
        return;
      }

      this.plan = yanit.data;
      this.asama = "plan";
    } catch (e) {
      this.hatayiIsle(e, "Önizleme başarısız oldu.");
    } finally {
      this.yukleniyor = false;
    }
  }

  /**
   * "Onayla ve Kaydet" ve (önbellek temizlenemediyse) "Yeniden Dene".
   *
   * Aynı dosya ve aynı özetle yeniden göndermek güvenlidir: oranlar zaten
   * yazıldıysa sunucu hiçbir şey yazmaz, önbelleği yeniden düşürür ve
   * "değişiklik yok" der.
   */
  async kaydet() {
    if (this.mesgul || !this.plan || !this.gonderilecek) return;

    const onbellekDenemesi = this.asama === "onbellek";
    if (this.yapilacakYok && !onbellekDenemesi) return;

    this.kaydediliyor = true;
    this.hata = "";
    this.planUyarisi = "";

    try {
      const yanit = await this.$http.post(this.adresTabani + 'kaydet', {
        faiz_turu_id: this.faizTuruId,
        dosya: this.gonderilecek,
        plan_ozeti: this.plan.plan_ozeti,
      });
      const veri = yanit.data;

      if (!veri || !veri.ozet || typeof veri.onbellek_temizlendi !== "boolean") {
        this.belirsizKayit(onbellekDenemesi);
        return;
      }

      // Şekli doğru 2xx: kaydın durumu artık kesin.
      this.kayitBelirsiz = false;
      this.$emit("kaydedildi");

      if (!veri.onbellek_temizlendi) {
        // Oranlar yazıldı ama önbellek düşmedi. Pencere açık kalır: yeniden
        // göndermek, önbelleği arayüzden düşürmenin tek yoludur.
        if (onbellekDenemesi) {
          this.hata = "Önbellek yine temizlenemedi. Biraz sonra yeniden deneyin ya da yazılım ekibine haber verin.";
        } else {
          this.onbellekMesaji = veri.message || "Oranlar kaydedildi ancak önbellek temizlenemedi.";
          this.asama = "onbellek";
        }
        return;
      }

      this.$toast.success(onbellekDenemesi ? "Önbellek temizlendi; oranlar bütün bürolar için geçerli." : (veri.message || "Oranlar kaydedildi."));
      this.kaydediliyor = false;
      this.$emit("input", false);
    } catch (e) {
      const yanit = e && e.response;
      if (yanit && yanit.status === 409 && yanit.data && this.planMi(yanit.data.plan)) {
        // Önizlemeden sonra kayıtlar değişmiş: hiçbir şey yazılmadı, güncel
        // liste yeniden gösterilir ve yeniden onay istenir.
        this.plan = yanit.data.plan;
        // 409 planı transaction içinde yeniden hesaplanır: önceki denemenin
        // yazıp yazmadığı bu planda görünür, belirsizlik kalmaz.
        this.kayitBelirsiz = false;
        // Önbellek adımından gelindiyse ilk kayıt yazılmıştı; sunucunun
        // "hiçbir şey yazılmadı" cümlesi yalnız bu son deneme için doğrudur.
        this.planUyarisi = onbellekDenemesi
            ? "Önbellek temizlenemeden kayıtlar yeniden değişmiş. Güncel listeyi inceleyip yeniden onaylayın; onay önbelleği de yeniler."
            : (yanit.data.message || "Kayıtlar önizlemeden sonra değişmiş. Güncel listeyi inceleyip yeniden onaylayın.");
        this.asama = "plan";
      } else if (!yanit || [500, 502, 504].indexOf(yanit.status) !== -1) {
        // Yanıt gelmedi ya da sunucu yarıda kesildi: kayıt yapılmış OLABİLİR.
        this.belirsizKayit(onbellekDenemesi);
      } else {
        this.hatayiIsle(e, "Kayıt başarısız oldu.");
        // 429/503/401/403/422 yalnız BU denemenin yazmadığını söyler; önceki
        // deneme belirsiz bittiyse onun sonucu hâlâ bilinmiyor.
        if (this.kayitBelirsiz && this.asama !== "hata") {
          this.hata += " Önceki denemenin sonucu hâlâ bilinmiyor; pencereyi kapatmadan yeniden deneyin.";
        }
      }
    } finally {
      this.kaydediliyor = false;
    }
  }

  /**
   * Kayıt isteğinin sonucu bilinmiyor. "Başarısız" demek yanıltır: oranlar
   * yazılmış olabilir. Arkadaki liste yenilenir, pencere açık kalır ve
   * yeniden gönderme önerilir (aynı dosya + aynı özet: yazıldıysa yeniden
   * yazılmaz, yalnız önbellek düşürülür).
   */
  belirsizKayit(onbellekDenemesi: boolean) {
    this.kayitBelirsiz = true;
    this.hata = onbellekDenemesi
        ? "Sunucudan yanıt alınamadı; önbelleğin temizlenip temizlenmediği bilinmiyor. Yeniden deneyin."
        : "Sunucudan yanıt alınamadı; kayıt yapılmış olabilir. Pencereyi kapatmadan \"Onayla ve Kaydet\"e yeniden basın: "
            + "oranlar yazıldıysa ikinci deneme yeniden yazmaz, yalnız önbelleği yeniler.";
    this.$emit("kaydedildi");
  }

  /**
   * Sayfada 12'den çok satır görünüyorsa tablo kendi içinde kayar ve başlığı
   * sabit kalır; 100 satırı gözden geçirirken sütun adları kaybolmaz.
   */
  uzunTablo(toplam: number, sayfaBoyu: number): boolean {
    return (sayfaBoyu === -1 ? toplam : Math.min(toplam, sayfaBoyu)) > 12;
  }

  boyutGoster(bayt: number): string {
    if (bayt < 1024) return bayt + " B";
    const kb = bayt / 1024;
    return kb < 1024 ? this.tekOndalik(kb) + " KB" : this.tekOndalik(kb / 1024) + " MB";
  }

  tekOndalik(sayi: number): string {
    return sayi.toFixed(1).replace(".", ",");
  }

  planMi(p: any): boolean {
    return !!p && !!p.faiz_turu && !!p.ozet && Array.isArray(p.eklenecek) && Array.isArray(p.guncellenecek)
        && typeof p.plan_ozeti === "string";
  }

  bellegeAl(dosya: File): Promise<File> {
    return new Promise((coz, reddet) => {
      const okuyucu = new FileReader();
      okuyucu.onload = () => coz(new File([okuyucu.result as ArrayBuffer], dosya.name, { type: dosya.type }));
      okuyucu.onerror = () => reddet(okuyucu.error);
      okuyucu.readAsArrayBuffer(dosya);
    });
  }

  async ornekIndir() {
    if (this.ornekIndiriliyor) return;
    this.ornekIndiriliyor = true;

    try {
      const yanit = await this.$http.get(this.adresTabani + 'ornek', { responseType: 'blob' });

      // HTTP 200 + JSON hata gövdesi Excel diye indirilmesin.
      if (!(yanit.data instanceof Blob) || yanit.data.type.indexOf('spreadsheetml') === -1) {
        this.$toast.error("Örnek Excel indirilemedi. Biraz sonra yeniden deneyin.");
        return;
      }

      const adres = window.URL.createObjectURL(yanit.data);
      const baglanti = document.createElement('a');
      baglanti.href = adres;
      baglanti.setAttribute('download', 'faiz-orani-toplu-ornek.xlsx');
      document.body.appendChild(baglanti);
      baglanti.click();
      document.body.removeChild(baglanti);
      window.URL.revokeObjectURL(adres);
    } catch (e) {
      // responseType 'blob' iken hata gövdesi de Blob gelir; mesaj durum
      // kodundan üretilir.
      this.$toast.error(this.hataMesaji(e, "Örnek Excel indirilemedi.", true));
    } finally {
      this.ornekIndiriliyor = false;
    }
  }

  /**
   * Satır bazlı hata listesi geldiyse hata penceresine geçer; diğer hatalar
   * bulunulan adımda gösterilir.
   */
  hatayiIsle(e: any, varsayilan: string) {
    const govde = e && e.response && e.response.data;
    this.hata = this.hataMesaji(e, varsayilan, false);

    if (e && e.response && e.response.status === 422 && govde && Array.isArray(govde.hatalar) && govde.hatalar.length) {
      this.hatalar = govde.hatalar;
      this.asama = "hata";
    }
  }

  hataMesaji(e: any, varsayilan: string, govdeOkunmaz: boolean): string {
    const yanit = e && e.response;
    if (!yanit) {
      return "Sunucuya ulaşılamadı.";
    }
    const govde = (!govdeOkunmaz && yanit.data) || {};
    if (yanit.status === 404) {
      return "Bu özellik sunucuda henüz yok. Yazılım ekibine haber verin.";
    }
    if (yanit.status === 401) {
      return govde.message || "Oturum doğrulanamadı. Yeniden giriş yapın.";
    }
    if (yanit.status === 403) {
      return govde.message || "Bu işlem için yetkiniz yok.";
    }
    if (yanit.status === 429) {
      return "Çok fazla istek gönderildi; kısa bir süre bekleyip tekrar deneyin.";
    }
    if (yanit.status === 503) {
      return govde.message || "Bu işlem şu anda kullanılamıyor.";
    }
    return govde.message || varsayilan;
  }

  tarihGoster(tarih: string): string {
    const parcalar = (tarih || "").substring(0, 10).split("-");
    return parcalar.length === 3 ? parcalar[2] + "." + parcalar[1] + "." + parcalar[0] : tarih;
  }

  oranGoster(oran: any): string {
    return oran === null || oran === undefined ? "—" : String(oran).replace(".", ",");
  }

  kodGoster(kod: any): string {
    return kod === null || kod === undefined ? "—" : String(kod);
  }

  kodDegisimi(satir: any): string {
    const parcalar: string[] = [];
    if (satir.eski.uyap_tip_kod !== satir.yeni.uyap_tip_kod) {
      parcalar.push("Tip: " + this.kodGoster(satir.eski.uyap_tip_kod) + " → " + this.kodGoster(satir.yeni.uyap_tip_kod));
    }
    if (satir.eski.uyap_genel_kod !== satir.yeni.uyap_genel_kod) {
      parcalar.push("Genel: " + this.kodGoster(satir.eski.uyap_genel_kod) + " → " + this.kodGoster(satir.yeni.uyap_genel_kod));
    }
    return parcalar.length ? parcalar.join(", ") : "—";
  }

  guncellemeNotu(satir: any): string {
    if (satir.gecerli_degisiyor === false) {
      return "Geçerli oran aynı; bu tarihteki eski mükerrer kayıt eşitlenecek.";
    }
    if (satir.kayit_sayisi > 1) {
      return "Bu tarihte " + satir.kayit_sayisi + " kayıt var; hepsi aynı orana getirilecek.";
    }
    return "";
  }
}
